import styled from "styled-components"

export const Form = styled.form`
  p {
    font-size: 18px;
    font-weight: 500;
  }
`
